import { createApiCall } from 'lib/base';

interface EditFundManagerBody {}

const EDIT_FUND_MANAGER = 'EDIT_FUND_MANAGER';

export const editFundManagerApi = createApiCall<
  EditFundManagerBody & { id: string; payload: any }
>(EDIT_FUND_MANAGER, ({ id, payload }) => ({
  endpoint: `api/admin/fund-managers/${id}`,
  method: 'PUT',
  body: payload,
}));

export default editFundManagerApi;
